import { Label } from "../Core/Label";
import classes from "./ViewField.module.css";
function ViewField({ label, labelStyles, value, type = "text", rightIcon }) {
  return (
    <div className={classes.main}>
      <Label>{label}</Label>
      <div
        className={[
          classes.value,
          type === "textarea" && classes.textarea,
        ].join(" ")}
      >
        <p>{value || "N/A"}</p> {type === "text" && <span>{rightIcon}</span>}
      </div>
    </div>
  );
}

export default ViewField;
